let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kKQq8")).then(() => parcelRequire('jM0Ga'));